/*
 * @Description: 优惠券
 * @Author: ywj
 * @Date: 2025-03-20 16:01:44
 * @LastEditTime: 2025-04-23 15:42:15
 * @LastEditors: ywj@originqc.com
 */
import React from "react";
import {message} from 'antd';
import './index.scss';
import effectBg from '../../imgs/effect.png'
import ineffectBg from '../../imgs/ineffect.png'
import effectTop from '../../imgs/effect_top.png'
import ineffectTop from '../../imgs/ineffect_top.png'
import { getCoupons, deleteById } from '@/api/coupon'
import DeleteModal from "../../../components/delete-modal";
interface IProps {
  useStatus: number,
  id:number,
  handleCouponList:()=>void;
  validTime: string,
  amount: string,
  useTime:string,
  type:number
}

// 状态：0：待领取 1：未使用；:2：已使用；3：已过期

const stateObj:any = {
  0: '立即领取',
  1: '待使用',
  2: '已使用',
  3: '已失效',


}
const Card: React.FC<IProps> = (props) => {
  const { useStatus, type, id, validTime, amount, useTime } = props;
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
console.log(useStatus, type,'type')

// 获取优惠券
const handleReceive =()=>{
  getCoupons({type:type,id:id}).then((res:any)=>{
    if(res.success) {
message.success('领取成功');
props?.handleCouponList();
    }else{        
      message.error(res.message);
    }
  })
}
// 刪除     
const handleDelete =()=>{
  deleteById({id:id}).then((res: any) => {
    if(res.success) {
message.success('删除成功');
props?.handleCouponList();
    }else{
      message.error(res.message);
    }
    
  })
}
  return <div
    className={`coupon-card card-${useStatus}`}
  // style={{ background: `url(${type !== 'ineffect' ? effectBg : ineffectBg}) no-repeat` }}
  >
    <div className="top"
      style={{ background: `url(${(useStatus === 0 || useStatus === 1) ? effectTop : ineffectTop}) no-repeat` }}
    >
      <span className="top-text">会员专享优惠券</span>
    </div>
    <p className="money">￥ <span className='num'>{amount}</span></p>
    {useStatus === 0 ? <p className="btn" onClick={handleReceive}>立即领取</p> :
      <>
        <p className="state">
          <span className="state-text">{stateObj[useStatus]}</span>
        </p></>}
    <div className={`content-btm card-${useStatus}`}>
      <p>有效期至：{validTime}  </p>
      <p> 仅限部分活动商品使用，不可叠加</p>
    </div>
    {(useStatus === 3) && <div className="delete-btn" onClick={()=>setShowDeleteModal(true)}>
      <span>删除</span>
    </div>}
    <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        handleDelete={handleDelete}
        title='删除提醒'
        content='请确认是否删除该优惠券？'
      />
  </div>;
}

export default Card;
